import { normalizeSoundSettings } from './alertSounds';

// BL-177 Step 2e: read and save a person's alert-sound settings (user_sound_settings, own row only).

/** The caller's settings with defaults filled in, plus their quiet hours. Never throws: a failed read gives defaults. */
export async function fetchMySoundSettings(client) {
    try {
        const { data, error } = await client.rpc('my_sound_settings');
        if (error) return { settings: normalizeSoundSettings(null), loaded: false };
        return { settings: normalizeSoundSettings(data), loaded: true };
    } catch {
        return { settings: normalizeSoundSettings(null), loaded: false };
    }
}

/** Saves the whole sound row for this person (insert or update). Returns an error message, or '' on success. */
export async function saveSoundSettings(client, { userId, orgId, settings }) {
    try {
        const { error } = await client.from('user_sound_settings').upsert({
            user_id: userId,
            org_id: orgId,
            sound_enabled: settings.soundEnabled,
            standard_tone: settings.standardTone,
            urgent_tone: settings.urgentTone,
            volume: settings.volume,
            push_silent: settings.pushSilent,
        }, { onConflict: 'user_id,org_id' });
        return error ? (error.message || 'Your sound settings could not be saved.') : '';
    } catch (failure) {
        return failure?.message || 'Your sound settings could not be saved.';
    }
}
